import React, { useRef } from 'react';
import { GameCard } from './GameCard';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface Game {
  id: string;
  title: string;
  category: string;
  thumbnail: string;
}

interface CategoryRowProps {
  title: string;
  games: Game[];
}

export const CategoryRow: React.FC<CategoryRowProps> = ({ title, games }) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const scrollAmount = direction === 'left' ? -600 : 600;
      scrollRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  if (!games || games.length === 0) return null;

  return (
    <div style={{ marginBottom: '40px', position: 'relative' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
        <h2 style={{ fontSize: '1.5rem', margin: 0, color: '#111827' }}>{title}</h2>
        
        {/* Scroll Controls */}
        <div style={{ display: 'flex', gap: '10px' }}>
          <button onClick={() => scroll('left')} style={{ background: '#e5e7eb', border: 'none', borderRadius: '50%', width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#4b5563' }}>
            <ChevronLeft size={20} />
          </button>
          <button onClick={() => scroll('right')} style={{ background: '#e5e7eb', border: 'none', borderRadius: '50%', width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#4b5563' }}>
            <ChevronRight size={20} />
          </button>
        </div>
      </div>

      <div 
        ref={scrollRef}
        style={{
          display: 'flex',
          gap: '20px',
          overflowX: 'auto',
          paddingBottom: '20px', // Prevent scrollbar cutting off shadows
          scrollbarWidth: 'none', // Hide scrollbar Firefox
          msOverflowStyle: 'none', // Hide scrollbar IE
        }}
      >
        <style>{`
          /* Hide scrollbar for Chrome, Safari and Opera */
          div::-webkit-scrollbar {
            display: none;
          }
        `}</style>
        
        {games.map(game => (
          <div key={game.id} style={{ flexShrink: 0, width: '280px' }}>
            <GameCard 
              id={game.id}
              title={game.title}
              category={game.category}
              thumbnail={game.thumbnail}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
